export function Pagination({
  page,
  totalPages,
  totalItems,
  onPageChange,
}: {
  page: number
  totalPages: number
  totalItems: number
  onPageChange: (page: number) => void
}) {
  if (totalPages <= 1) return null
  return (
    <div className="flex items-center justify-between text-xs font-semibold text-slate-500">
      <span>
        Page <strong className="text-slate-900">{page}</strong> of <strong className="text-slate-900">{totalPages}</strong> · <span className="font-mono text-slate-600">{totalItems.toLocaleString()} total</span>
      </span>
      <div className="flex gap-1.5">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="rounded-lg border border-slate-200 bg-white px-3 py-1 font-mono text-xs font-semibold text-slate-700 shadow-sm disabled:opacity-40 hover:border-sky-300 hover:text-sky-700 disabled:hover:border-slate-200 disabled:hover:text-slate-700 transition-all"
        >
          ← Prev
        </button>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="rounded-lg border border-slate-200 bg-white px-3 py-1 font-mono text-xs font-semibold text-slate-700 shadow-sm disabled:opacity-40 hover:border-sky-300 hover:text-sky-700 disabled:hover:border-slate-200 disabled:hover:text-slate-700 transition-all"
        >
          Next →
        </button>
      </div>
    </div>
  )
}
